import { useState, useEffect } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL

const NIVELES = ['Todos', 'PRE', 'A1', 'A2', 'B1', 'B2', 'C1']
const COLORES_NIVEL = {
  PRE: '#94A3B8', A1: '#22C55E', A2: '#3B82F6', B1: '#8B5CF6', B2: '#F59E0B', C1: '#EF4444'
}
const NOMBRE_CATEGORIA = { vocabulario: 'Vocabulario', gramatica: 'Gramática', mixta: 'Mixta' }
const COLOR_CATEGORIA = { vocabulario: '#3B82F6', gramatica: '#8B5CF6', mixta: '#059669' }

/* Seccion de Worksheets: guias de practica en PDF, organizadas
   por nivel (PRE a C1). Cada tarjeta descarga un PDF generado por
   el servidor con ejercicios y hoja de respuestas al final. La
   primera descarga de cada worksheet otorga XP al estudiante. */
export default function Worksheets({ usuario, onCambio }) {
  const [cargando,   setCargando]   = useState(true)
  const [worksheets, setWorksheets] = useState([])
  const [filtro,     setFiltro]     = useState('Todos')
  const [error,      setError]      = useState(null)

  useEffect(() => {
    setCargando(true)
    setError(null)
    axios.get(`${API}/worksheets`).then(res => {
      setWorksheets(res.data.datos || [])
    }).catch(err => {
      console.error('Error cargando worksheets:', err)
      setError('No pudimos cargar las worksheets. Intenta de nuevo.')
    }).finally(() => setCargando(false))
  }, [])

  function alDescargar() {
    // Da tiempo a que el servidor registre la descarga y el XP
    // antes de refrescar las estadisticas del dashboard.
    if (onCambio) setTimeout(onCambio, 1500)
  }

  const visibles = filtro === 'Todos' ? worksheets : worksheets.filter(w => w.nivel === filtro)

  return (
    <div style={{ animation: 'fadeIn .3s ease both', maxWidth: 960 }}>
      <div style={{ background: 'linear-gradient(135deg,var(--azul-oscuro),var(--azul))', borderRadius: 18, padding: '28px 30px', color: '#fff', marginBottom: 26 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <span style={{ fontSize: 40 }}>📄</span>
          <div>
            <h1 style={{ fontSize: 24, fontWeight: 800 }}>Worksheets</h1>
            <p style={{ fontSize: 14, opacity: .85, marginTop: 4 }}>
              Hojas de práctica en PDF para cada nivel. Descarga, imprime o completa en pantalla.
            </p>
          </div>
        </div>
      </div>

      {error && (
        <div style={{ background: '#FEE2E2', color: '#B91C1C', borderRadius: 10, padding: '10px 14px', fontSize: 13, marginBottom: 16 }}>
          {error}
        </div>
      )}

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 22 }}>
        {NIVELES.map(n => (
          <button key={n} onClick={() => setFiltro(n)}
            style={{
              padding: '7px 16px', borderRadius: 999, border: '1.5px solid ' + (filtro === n ? 'var(--azul)' : 'var(--gris-borde)'),
              background: filtro === n ? 'var(--azul)' : '#fff', color: filtro === n ? '#fff' : 'var(--gris-texto)',
              fontFamily: 'inherit', fontSize: 13, fontWeight: 700, cursor: 'pointer'
            }}>
            {n}
          </button>
        ))}
      </div>

      {cargando && (
        <div style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--gris-texto)' }}>
          Cargando worksheets...
        </div>
      )}

      {!cargando && !visibles.length && (
        <div style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--gris-texto)' }}>
          <div style={{ fontSize: 44, marginBottom: 12 }}>📄</div>
          <p>Todavía no hay worksheets para este nivel.</p>
        </div>
      )}

      {!cargando && !!visibles.length && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: 16 }}>
          {visibles.map(w => (
            <div key={w.id} style={{ background: '#fff', border: '1px solid var(--gris-borde)', borderRadius: 16, overflow: 'hidden' }}>
              <div style={{ height: 5, background: COLORES_NIVEL[w.nivel] || 'var(--azul)' }} />
              <div style={{ padding: 20 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                  <span style={{ background: COLORES_NIVEL[w.nivel] || 'var(--azul)', color: '#fff', fontSize: 11, fontWeight: 800, padding: '3px 10px', borderRadius: 999 }}>
                    {w.nivel}
                  </span>
                  {w.categoria && (
                    <span style={{ background: (COLOR_CATEGORIA[w.categoria] || 'var(--gris-texto)') + '20', color: COLOR_CATEGORIA[w.categoria] || 'var(--gris-texto)', fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 999 }}>
                      {NOMBRE_CATEGORIA[w.categoria] || w.categoria}
                    </span>
                  )}
                </div>
                <h3 style={{ fontSize: 16, fontWeight: 800, marginBottom: 4 }}>{w.titulo}</h3>
                {w.tema && (
                  <p style={{ fontSize: 12, color: 'var(--azul)', fontWeight: 700, marginBottom: 8 }}>{w.tema}</p>
                )}
                <p style={{ fontSize: 12.5, color: 'var(--gris-texto)', lineHeight: 1.4, marginBottom: 18, minHeight: 34 }}>
                  {w.descripcion}
                </p>
                <a href={`${API}/worksheets/${w.id}/pdf?usuario_id=${usuario?.id || ''}`}
                  target="_blank" rel="noreferrer" onClick={alDescargar}
                  style={{
                    display: 'block', textAlign: 'center', padding: '10px', borderRadius: 10,
                    background: 'var(--dorado)', color: '#fff', fontFamily: 'inherit', fontSize: 13.5, fontWeight: 700,
                    textDecoration: 'none', cursor: 'pointer'
                  }}>
                  ⬇ Descargar PDF
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
